/* eslint-disable import/prefer-default-export */
/* Populated by react-webpack-redux:action */
export const SET_TOKEN = 'SET_TOKEN';
export const CUSTOMER_JOURNEY_HOTEL = 'CUSTOMER_JOURNEY_HOTEL';
export const CUSTOMER_JOURNEY_HOTEL_SUCCESS = 'CUSTOMER_JOURNEY_HOTEL_SUCCESS';
export const CUSTOMER_JOURNEY_HOTEL_ERROR = 'CUSTOMER_JOURNEY_HOTEL_ERROR';
export const CUSTOMER_JOURNEY_RESERVATION = 'CUSTOMER_JOURNEY_RESERVATION';
export const CUSTOMER_JOURNEY_RESERVATION_SUCCESS = 'CUSTOMER_JOURNEY_RESERVATION_SUCCESS';
export const CUSTOMER_JOURNEY_RESERVATION_ERROR = 'CUSTOMER_JOURNEY_RESERVATION_ERROR';
export const CUSTOMER_JOURNEY_CATEGORIES = 'CUSTOMER_JOURNEY_CATEGORIES';
export const CUSTOMER_JOURNEY_CATEGORIES_SUCCESS = 'CUSTOMER_JOURNEY_CATEGORIES_SUCCESS';
export const CUSTOMER_JOURNEY_CATEGORIES_ERROR = 'CUSTOMER_JOURNEY_CATEGORIES_ERROR';
export const CUSTOMER_JOURNEY_EVENTS_CATEGORIES = 'CUSTOMER_JOURNEY_EVENTS_CATEGORIES';
export const CUSTOMER_JOURNEY_EVENTS_CATEGORIES_SUCCESS = 'CUSTOMER_JOURNEY_EVENTS_CATEGORIES_SUCCESS';
export const CUSTOMER_JOURNEY_EVENTS_CATEGORIES_ERROR = 'CUSTOMER_JOURNEY_EVENTS_CATEGORIES_ERROR';
export const CUSTOMER_JOURNEY_EVENTS_CATEGORY = 'CUSTOMER_JOURNEY_EVENTS_CATEGORY';
export const CUSTOMER_JOURNEY_EVENTS_CATEGORY_SUCCESS = 'CUSTOMER_JOURNEY_EVENTS_CATEGORY_SUCCESS';
export const CUSTOMER_JOURNEY_EVENTS_CATEGORY_ERROR = 'CUSTOMER_JOURNEY_EVENTS_CATEGORY_ERROR';
export const CUSTOMER_JOURNEY_ATTRACTIONS = 'CUSTOMER_JOURNEY_ATTRACTIONS';
export const CUSTOMER_JOURNEY_ATTRACTIONS_SUCCESS = 'CUSTOMER_JOURNEY_ATTRACTIONS_SUCCESS';
export const CUSTOMER_JOURNEY_ATTRACTIONS_ERROR = 'CUSTOMER_JOURNEY_ATTRACTIONS_ERROR';
export const CUSTOMER_JOURNEY_MENU = 'CUSTOMER_JOURNEY_MENU';
export const CUSTOMER_JOURNEY_MENU_SUCCESS = 'CUSTOMER_JOURNEY_MENU_SUCCESS';
export const CUSTOMER_JOURNEY_MENU_ERROR = 'CUSTOMER_JOURNEY_MENU_ERROR';
export const CUSTOMER_JOURNEY_VENUES = 'CUSTOMER_JOURNEY_VENUES';
export const CUSTOMER_JOURNEY_VENUES_SUCCESS = 'CUSTOMER_JOURNEY_VENUES_SUCCESS';
export const CUSTOMER_JOURNEY_VENUES_ERROR = 'CUSTOMER_JOURNEY_VENUES_ERROR';
export const CUSTOMER_JOURNEY_SERVICES = 'CUSTOMER_JOURNEY_SERVICES';
export const CUSTOMER_JOURNEY_SERVICES_SUCCESS = 'CUSTOMER_JOURNEY_SERVICES_SUCCESS';
export const CUSTOMER_JOURNEY_SERVICES_ERROR = 'CUSTOMER_JOURNEY_SERVICES_ERROR';
export const CUSTOMER_JOURNEY_SERVICES_BOOK = 'CUSTOMER_JOURNEY_SERVICES_BOOK';
export const CUSTOMER_JOURNEY_SERVICES_BOOK_SUCCESS = 'CUSTOMER_JOURNEY_SERVICES_BOOK_SUCCESS';
export const CUSTOMER_JOURNEY_SERVICES_BOOK_ERROR = 'CUSTOMER_JOURNEY_SERVICES_BOOK_ERROR';
export const SET_LANG = 'SET_LANG';
export const CUSTOMER_JOURNEY_LOGIN = 'CUSTOMER_JOURNEY_LOGIN';
export const CUSTOMER_JOURNEY_LOGIN_SUCCESS = 'CUSTOMER_JOURNEY_LOGIN_SUCCESS';
export const CUSTOMER_JOURNEY_LOGIN_ERROR = 'CUSTOMER_JOURNEY_LOGIN_ERROR';
export const CUSTOMER_JOURNEY_LOGIN_RESERVATION = 'CUSTOMER_JOURNEY_LOGIN_RESERVATION';
export const CUSTOMER_JOURNEY_LOGIN_RESERVATION_SUCCESS = 'CUSTOMER_JOURNEY_LOGIN_RESERVATION_SUCCESS';
export const CUSTOMER_JOURNEY_LOGIN_RESERVATION_ERROR = 'CUSTOMER_JOURNEY_LOGIN_RESERVATION_ERROR';
export const CUSTOMER_JOURNEY_WEATHER = 'CUSTOMER_JOURNEY_WEATHER';
export const CUSTOMER_JOURNEY_WEATHER_ERROR = 'CUSTOMER_JOURNEY_WEATHER_ERROR';
export const CUSTOMER_JOURNEY_WEATHER_SUCCESS = 'CUSTOMER_JOURNEY_WEATHER_SUCCESS';
export const CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE = 'CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE';
export const CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_SUCCESS = 'CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_SUCCESS';
export const CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_ERROR = 'CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE_ERROR';
export const DURING_STAY_SURVEY_SEND_ANSWER = 'DURING_STAY_SURVEY_SEND_ANSWER';
export const DURING_STAY_SURVEY_SEND_ANSWER_SUCCESS = 'DURING_STAY_SURVEY_SEND_ANSWER_SUCCESS';
export const DURING_STAY_SURVEY_SEND_ANSWER_ERROR = 'DURING_STAY_SURVEY_SEND_ANSWER_ERROR';
export const DURING_STAY_SURVEY_GET_ANSWER = 'DURING_STAY_SURVEY_GET_ANSWER';
export const DURING_STAY_SURVEY_GET_ANSWER_SUCCESS = 'DURING_STAY_SURVEY_GET_ANSWER_SUCCESS';
export const DURING_STAY_SURVEY_GET_ANSWER_ERROR = 'DURING_STAY_SURVEY_GET_ANSWER_ERROR';
export const CUSTOMER_JOURNEY_NEWS_CATEGORIES = 'CUSTOMER_JOURNEY_NEWS_CATEGORIES';
export const CUSTOMER_JOURNEY_NEWS_CATEGORIES_SUCCESS = 'CUSTOMER_JOURNEY_NEWS_CATEGORIES_SUCCESS';
export const CUSTOMER_JOURNEY_NEWS_CATEGORIES_ERROR = 'CUSTOMER_JOURNEY_NEWS_CATEGORIES_ERROR';
export const CUSTOMER_JOURNEY_NEWS_CATEGORY = 'CUSTOMER_JOURNEY_NEWS_CATEGORY';
export const CUSTOMER_JOURNEY_NEWS_CATEGORY_SUCCESS = 'CUSTOMER_JOURNEY_NEWS_CATEGORY_SUCCESS';
export const CUSTOMER_JOURNEY_NEWS_CATEGORY_ERROR = 'CUSTOMER_JOURNEY_NEWS_CATEGORY_ERROR';



// WEBPACK FOOTER //
// ./actions/const.js